import gql from 'graphql-tag';

export default gql`
mutation updateReport($obj: updateReportInput!) {
  updateReport(object: $obj) {
    updatedReport
  }
}
`;
